import React from "react";
import CommonLayout from "../CommonLayout";
import "./index.css";

const TermsAndConditions: React.FC = () => {
  return (
    <CommonLayout
      title="Terms & Condition"
      showBackButton={true}
    >
      <iframe
        className="height100 width100 iframeClass noBorder"
        src="https://www.ink-aa.com/terms-conditions.html"
        title="TermsAndCondition"
        frameBorder="0"
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      />
    </CommonLayout>
  );
};

export default TermsAndConditions;
